// @flow
import { colors } from '../config';
import type { Color } from '../types';

export default function sanitizeColor(value: mixed): Color | void {
  return typeof value === 'string' && colors[value] ? colors[value] : undefined;
}
